export const formatFileSize = (bytes?: number | null): string => {
	if (bytes == null || Number.isNaN(bytes)) return '-'

	if (bytes < 1024) return `${bytes} B`
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
